"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Screen = require("./Screen");
Object.keys(_Screen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Screen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Screen[key];
    }
  });
});
var _SectionStatus = require("./SectionStatus");
Object.keys(_SectionStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SectionStatus[key];
    }
  });
});
var _BillingScreen = require("./BillingScreen");
Object.keys(_BillingScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BillingScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BillingScreen[key];
    }
  });
});
var _PatientScreen = require("./PatientScreen");
Object.keys(_PatientScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PatientScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PatientScreen[key];
    }
  });
});
var _SectionIndexScreen = require("./SectionIndexScreen");
Object.keys(_SectionIndexScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionIndexScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SectionIndexScreen[key];
    }
  });
});
var _VideoChatCubbyHeader = require("./VideoChatCubbyHeader");
Object.keys(_VideoChatCubbyHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VideoChatCubbyHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoChatCubbyHeader[key];
    }
  });
});
var _NotesScreen = require("./NotesScreen");
Object.keys(_NotesScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotesScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NotesScreen[key];
    }
  });
});
var _PrescriptionsScreen = require("./PrescriptionsScreen");
Object.keys(_PrescriptionsScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PrescriptionsScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PrescriptionsScreen[key];
    }
  });
});